import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import {
  Box,
  Container,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ThemeProvider,
} from "@mui/material";
import { ArrowForward, MenuOpenRounded } from "@mui/icons-material";
import { theme } from "../Theme";
import Typography from "@mui/material/Typography";
import Login from "./Login";
import LogoutButton from "./LogoutButton";
import SignUpModal from "./SignUpModal";
import FindIdModal from "./FindIdModal";
import FindPasswordModal from "./FindPasswordModal";
import AnnouncementListModal from "./AnnouncementListodal";
import InquiryListModal from "./InquiryListModal";
import { useNavigate } from "react-router-dom";

const Header: React.FC = () => {
  const navigate = useNavigate();
  const username = localStorage.getItem("username");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      setIsDrawerOpen(open);
    };

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    setIsLoggedIn(!!token);
  }, []);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true); // 로그인 성공 시 상태 변경
  };

  const handleLogoutSuccess = () => {
    setIsLoggedIn(false); // 로그아웃 성공 시 상태 변경
  };

  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);

  const toggleSignupModal = () => {
    setIsSignupModalOpen(!isSignupModalOpen);
  };

  const [isFindIdModalOpen, setIsFindIdModalOpen] = useState(false);

  const toggleFindIdModal = () => {
    setIsFindIdModalOpen(!isFindIdModalOpen);
  };

  const [isFindPasswordModalOpen, setIsFindPasswordModalOpen] = useState(false);

  const toggleFindPasswordModal = () => {
    setIsFindPasswordModalOpen(!isFindPasswordModalOpen);
  };

  const [isOpenAnnouncements, setIsOpenAnnouncements] = useState(false);

  const toggleOpenAnnouncements = () => {
    setIsOpenAnnouncements(!isOpenAnnouncements);
  };

  const [isOpenInquiries, setIsOpenInquiries] = useState(false);

  const toggleOpenInquiries = () => {
    setIsOpenInquiries(!isOpenInquiries);
  };

  return (
    <ThemeProvider theme={theme}>
      <AppBar
        position="static"
        sx={{ backgroundColor: "#fff", boxShadow: "none", marginTop: "1rem" }}
      >
        <Container maxWidth="lg">
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <Box sx={{ flexGrow: 1, textAlign: "center" }}>
              <img
                src="/header/header-logo.png"
                alt="Linknity Logo"
                style={{ maxHeight: "50px", cursor: "pointer" }}
                onClick={() => navigate("/home")}
              />
              <img
                src="/header/header-linknity.png"
                alt="Linknity Text"
                style={{
                  maxHeight: "50px",
                  marginLeft: "1rem",
                  cursor: "pointer",
                }}
                onClick={() => navigate("/home")}
              />
            </Box>

            {/* 아이콘 버튼을 오른쪽 끝에 배치 */}
            <IconButton
              edge="end"
              aria-label="menu"
              color="primary"
              sx={{
                cursor: "pointer",
                fontSize: 32,
                padding: 0,
                "&:hover": {
                  backgroundColor: "#e0f7fa",
                },
              }}
              onClick={toggleDrawer(true)}
            >
              <MenuOpenRounded sx={{ fontSize: 32 }} />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      {/* 사이드바 구현 */}
      <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        <Box sx={{ width: "20rem" }} role="presentation">
          <List>
            {isLoggedIn ? (
              // 로그인 되어 있을 때 보여줄 항목
              <>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="body1" style={{ margin: "auto" }}>
                    {username} 님
                  </Typography>
                  <LogoutButton onLogout={handleLogoutSuccess} />
                </Box>
              </>
            ) : (
              // 로그인 되어 있지 않을 때 보여줄 항목
              <>
                <Login onLogin={handleLoginSuccess} />
              </>
            )}

            {/* Service 텍스트와 관련 메뉴 */}
            <ListItem>
              <Typography
                variant="h6"
                sx={{
                  borderBottom: `2px solid ${theme.palette.success.main}`,
                }}
              >
                MEMBER
              </Typography>
            </ListItem>
            <ListItem onClick={toggleSignupModal} sx={{ cursor: "pointer" }}>
              <Box
                sx={{
                  pl: 4,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <ListItemText primary="회원가입" />
                <ArrowForward
                  sx={{ marginLeft: "auto", color: theme.palette.success.main }}
                />
              </Box>
            </ListItem>
            <SignUpModal open={isSignupModalOpen} onClose={toggleSignupModal} />
            <Divider
              sx={{
                borderBottomWidth: 1,
                backgroundColor: `${theme.palette.success.main}`,
                marginLeft: "32px",
                marginRight: "16px",
              }}
            />
            <ListItem onClick={toggleFindIdModal} sx={{ cursor: "pointer" }}>
              <Box
                sx={{
                  pl: 4,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <ListItemText primary="아이디 찾기" />
                <ArrowForward
                  sx={{ marginLeft: "auto", color: theme.palette.success.main }}
                />
              </Box>
            </ListItem>
            <FindIdModal open={isFindIdModalOpen} onClose={toggleFindIdModal} />
            <Divider
              sx={{
                borderBottomWidth: 1,
                backgroundColor: `${theme.palette.success.main}`,
                marginLeft: "32px",
                marginRight: "16px",
              }}
            />
            {/*<ListItem onClick={toggleFindPasswordModal} sx={{ cursor: 'pointer' }}>*/}
            {/*    <Box sx={{ pl: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>*/}
            {/*        <ListItemText primary="비밀번호 찾기" />*/}
            {/*        <ArrowForward sx={{ marginLeft: 'auto', color: theme.palette.success.main }} />*/}
            {/*    </Box>*/}
            {/*</ListItem>*/}
            <FindPasswordModal
              open={isFindPasswordModalOpen}
              onClose={toggleFindPasswordModal}
            />
            <Divider
              sx={{
                borderBottomWidth: 1,
                backgroundColor: `${theme.palette.success.main}`,
                marginLeft: "32px",
                marginRight: "16px",
              }}
            />

            {/* Service 텍스트와 관련 메뉴 */}
            <ListItem>
              <Typography
                variant="h6"
                sx={{
                  borderBottom: `2px solid ${theme.palette.secondary.main}`,
                }}
              >
                SERVICE
              </Typography>
            </ListItem>
            <ListItem
              onClick={toggleOpenAnnouncements}
              sx={{ cursor: "pointer" }}
            >
              <Box
                sx={{
                  pl: 4,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <ListItemText primary="공지사항" />
                <ArrowForward
                  sx={{
                    marginLeft: "auto",
                    color: theme.palette.secondary.main,
                  }}
                />
              </Box>
            </ListItem>
            <AnnouncementListModal
              open={isOpenAnnouncements}
              onClose={toggleOpenAnnouncements}
            />
            <Divider
              sx={{
                borderBottomWidth: 1,
                backgroundColor: `${theme.palette.secondary.main}`,
                marginLeft: "32px",
                marginRight: "16px",
              }}
            />

            {/*TODO: 이거 클릭할 때부터 로그인 여부 확인할 건지 결정 필요. 그렇다면 문의도 자신이 생성한 것만 볼 수 있음. 아니라면 작성자도 함께 표시하기*/}
            <ListItem onClick={toggleOpenInquiries} sx={{ cursor: "pointer" }}>
              <Box
                sx={{
                  pl: 4,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <ListItemText primary="문의하기" />
                <ArrowForward
                  sx={{
                    marginLeft: "auto",
                    color: theme.palette.secondary.main,
                  }}
                />
              </Box>
            </ListItem>
            <InquiryListModal
              open={isOpenInquiries}
              onClose={toggleOpenInquiries}
            />
            <Divider
              sx={{
                borderBottomWidth: 1,
                backgroundColor: `${theme.palette.secondary.main}`,
                marginLeft: "32px",
                marginRight: "16px",
              }}
            />
          </List>
        </Box>
      </Drawer>
    </ThemeProvider>
  );
};

export default Header;
